var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetectLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.9498V19.9498C7.91672 19.7165 6.12905 18.8541 4.63705 17.3628C3.14505 15.8715 2.28272 14.0838 2.05005 11.9998H0.0500488V9.9998H2.05005C2.28338 7.91647 3.14605 6.1288 4.63805 4.6368C6.13005 3.1448 7.91738 2.28247 10 2.0498V0.0498047H12V2.0498C14.0834 2.28314 15.8711 3.1458 17.3631 4.6378C18.8551 6.12981 19.7174 7.91714 19.9501 9.9998H21.9501V11.9998H19.9501C19.7167 14.0831 18.8544 15.8708 17.3631 17.3628C15.8717 18.8548 14.084 19.7171 12 19.9498V21.9498H10ZM11 17.9998C12.9334 17.9998 14.5834 17.3165 15.95 15.9498C17.3167 14.5831 18 12.9331 18 10.9998C18 9.06647 17.3167 7.41647 15.95 6.0498C14.5834 4.68314 12.9334 3.9998 11 3.9998C9.06672 3.9998 7.41672 4.68314 6.05005 6.0498C4.68338 7.41647 4.00005 9.06647 4.00005 10.9998C4.00005 12.9331 4.68338 14.5831 6.05005 15.9498C7.41672 17.3165 9.06672 17.9998 11 17.9998ZM11 14.9998C9.90005 14.9998 8.95838 14.6081 8.17505 13.8248C7.39172 13.0415 7.00005 12.0998 7.00005 10.9998C7.00005 9.8998 7.39172 8.95814 8.17505 8.1748C8.95838 7.39147 9.90005 6.9998 11 6.9998C12.1 6.9998 13.0417 7.39147 13.825 8.1748C14.6084 8.95814 15 9.8998 15 10.9998C15 12.0998 14.6084 13.0415 13.825 13.8248C13.0417 14.6081 12.1 14.9998 11 14.9998ZM11 12.9998C11.55 12.9998 12.021 12.8041 12.413 12.4128C12.805 12.0215 13.0007 11.5505 13 10.9998C12.9994 10.4491 12.8037 9.97847 12.413 9.5878C12.0224 9.19714 11.5514 9.00114 11 8.9998C10.4487 8.99847 9.97805 9.19447 9.58805 9.5878C9.19805 9.98114 9.00205 10.4518 9.00005 10.9998C8.99805 11.5478 9.19405 12.0188 9.58805 12.4128C9.98205 12.8068 10.4527 13.0025 11 12.9998Z",
    fill: "url(#paint0_linear_16681_78284)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16681_78284",
    x1: -6.29554,
    y1: -5.88145,
    x2: 33.7698,
    y2: -1.22605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345263,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563723,
    stopColor: "#CB2129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0BA0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectLocation);
export default __webpack_public_path__ + "static/media/detect-location.53da67cb8289f99a5ee3befc67c17ecd.svg";
export { ForwardRef as ReactComponent };